import React, { useContext, useState, useEffect } from 'react';
import Header from '../Header/AppHeader';
import Axiosfetch from '../Common/Axiosfetch';
import baseURL from '../Common/Config';
import moment from 'moment';
import Alert from 'react-s-alert';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/slide.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faReceipt, faSyncAlt } from '@fortawesome/free-solid-svg-icons';
import { ThemeContext } from '../Common/ThemeProvider';
import FailureAlert from '../Common/Failure';
import Regions from '../Common/Region';
import Select from 'react-select';

const GstType = {
    IGst: 0,
    CGst: 2.5,
    SGst: 2.5
};

const FinalInvoice = () => {
    const { CurrentTheme } = useContext(ThemeContext);
    // eslint-disable-next-line
    const [companyInfo, setCompanyInfo] = useState([]);
    const [hideQuotation, sethideQuotation] = useState("none");
    const [SelectedQuotation, setSelectedQuotation] = useState("");
    const [SelectedQuotationInfo, setSelectedQuotationInfo] = useState([]);
    const [QuotationData, setQuotationData] = useState([]);
    const [QuotationInfo, setQuotationInfo] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState({});
    const [totalAmount, settotalAmount] = useState(0);
    const [InterState, setInterState] = useState(false);
    const [Gst, setGst] = useState(GstType);
    const [RegionSymbol, setRegionSymbol] = useState({});
    const [PaymentInfo, setPaymentInfo] = useState(0);

    useEffect(() => {
        GetQuotations();

        if (localStorage.getItem("CompanyInfo") !== null) {
            var companyDetails = JSON.parse(localStorage.getItem("CompanyInfo"));
            setCompanyInfo(companyDetails);
            var region = Regions.filter(r => r.Code === companyDetails.CountryCode);
            if (region.length > 0) {
                setRegionSymbol(region[0]);
            }
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const hideQuotationModal = () => {
        sethideQuotation(hideQuotation === "none" ? "block" : "none");
    };

    const GetQuotations = () => {
        var userData = localStorage.getItem("userData") ? JSON.parse(localStorage.getItem("userData")) : null;
        Axiosfetch(baseURL + "GetActiveQuotationsByOrgID", "POST", { OrgID: userData.OrganizationID }, quotationDataSuccess, Failure);
    };

    const quotationDataSuccess = (data) => {
        if (data.length > 0) {
            setQuotationData(data);
            let quotation = [];
            data.forEach(Quotation => {
                let quotationNumber = "#" + Quotation.QuoteID + "_" +
                    moment(Quotation.createdAt).local().format("DDMMYYYY");
                quotation.push({ value: Quotation._id, label: quotationNumber });
            });
            setQuotationInfo(quotation);
        }
        else {
            setQuotationInfo([]);
            setQuotationData([]);
        }
    };

    const ImportQuotationDetails = () => {
        let quotation = SelectedQuotation;
        let SelectedQuotationDetails = QuotationData.filter(q => { return q._id === quotation });
        if (SelectedQuotationDetails.length > 0) {
            setSelectedCustomer(SelectedQuotationDetails[0].Customer);
        }

        if (quotation !== "" && PaymentInfo !== 0) {
            if (ValidateInvoice()) {
                setSelectedQuotationInfo(SelectedQuotationDetails);
                UpDateTotalAmount();
                sethideQuotation(hideQuotation === "none" ? "block" : "none");
            }
            else {
                Alert.error((RegionSymbol.TaxSystem !== undefined ? RegionSymbol.TaxSystem : "GST") + " Field cannot be Zero(0)", {
                    position: 'bottom-right',
                    effect: 'slide',
                    html: false
                });
            }
        }
        else {
            Alert.error("Please select all the mandatory fields", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const ValidateInvoice = () => {
        if (InterState && Gst.IGst > 0) {
            return true;
        }
        else if (!InterState && Gst.CGst > 0 && Gst.SGst > 0) {
            return true;
        }

        return false;
    };

    const UpDateTotalAmount = () => {
        let quotation = SelectedQuotation;
        let SelectedQuotationDetails = QuotationData.filter(q => { return q._id === quotation });
        let value = 0;
        if (SelectedQuotationDetails.length > 0) {
            value = SelectedQuotationDetails[0].PackingCharges +
                SelectedQuotationDetails[0].LoadingCharges +
                SelectedQuotationDetails[0].PickupCharges +
                SelectedQuotationDetails[0].TransportCharges +
                SelectedQuotationDetails[0].UnloadingCharges +
                SelectedQuotationDetails[0].UnpackingCharges +
                SelectedQuotationDetails[0].CarTransportCharges +
                SelectedQuotationDetails[0].OtherCharges;
        }

        settotalAmount(value.toFixed(2));
    };

    const ValidateInvoiceData = (products) => {
        let productErr = "";
        if (products.QuotationID === "") {
            productErr = "Please select valid Quotation.";
        }
        else if (products.InterState === 1 && products.IGST <= 0) {
            productErr = "Please enter valid IGST.";
        }
        else if (products.InterState === 0 && products.CGST <= 0) {
            productErr = "Please enter valid CGST.";
        }
        else if (products.InterState === 0 && products.SGST <= 0) {
            productErr = "Please enter valid SGST.";
        }
        else if (products.InvoiceCredit === 0) {
            productErr = "Please select Invoice Credit.";
        }

        if (productErr !== "") {
            Alert.error(productErr, {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });

            return false;
        }

        return true;
    };

    const GenerateInvoice = () => {
        var userData = localStorage.getItem("userData") ? JSON.parse(localStorage.getItem("userData")) : null;
        if (userData !== null) {
            let paymentCredit = parseInt(PaymentInfo);
            if (paymentCredit > 0) {
                let InvoiceData = {
                    InvoiceID: 0,
                    QuotationID: SelectedQuotation,
                    InterState: InterState ? 1 : 0,
                    IGST: InterState ? Gst.IGst : 0,
                    CGST: InterState ? 0 : Gst.CGst,
                    SGST: InterState ? 0 : Gst.SGst,
                    Status: 1,
                    InvoiceCredit: paymentCredit,
                    OrgID: userData.OrganizationID,
                    CreatedBy: userData._id,
                    Remarks: "",
                    IsDeleted: 0
                };

                if (ValidateInvoiceData(InvoiceData)) {
                    Axiosfetch(baseURL + "CreateInvoice", "POST", InvoiceData, InvoiceCreationSuccess, Failure);
                }
            }
            else {
                Alert.error("Please Select valid Credit option", {
                    position: 'bottom-right',
                    effect: 'slide',
                    html: false
                });
            }
        }
        else {
            Alert.error("Error occured While Generating Invoices. Please login to the application again before attempting the steps.", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const SelectedQuotationChange = (QuotationData) => {
        let quotationData = QuotationData ? QuotationData.value : "";
        if (quotationData !== "") {
            setSelectedQuotation(quotationData);
        }
        else {
            setSelectedQuotationInfo([]);
            setSelectedCustomer({});
            setGst(GstType);
        }
    };

    const InvoiceCreationSuccess = (data) => {
        if (data !== "") {
            Alert.success("Invoice Created Successfully.", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });

            setGst(GstType);
            settotalAmount(0);
            setSelectedCustomer({});
            setPaymentInfo(0);
            setInterState(false);
            setSelectedQuotationInfo([]);
        }
        else {
            Alert.error("Error while creating Invoices. Please try again", {
                position: 'bottom-right',
                effect: 'slide',
                html: false
            });
        }
    };

    const OnCheckedChange = (e) => {
        setInterState(e.target.checked);

        const GstType = {
            IGst: e.target.checked ? 18 : 0,
            CGst: e.target.checked ? 0 : 2.5,
            SGst: e.target.checked ? 0 : 2.5
        };

        setGst(GstType)

    };

    const onNumberChange = (e) => {
        let value = e.target.value === "" ? 0 : parseFloat(e.target.value);
        setGst({ ...Gst, [e.target.name]: value });
    };

    const getCreditPaymentDetails = (paymentInfo) => {
        setPaymentInfo(parseInt(paymentInfo));
    }

    const Failure = (err) => {
        FailureAlert(err);
    };

    return (
        <div>
            <Header></Header>
            <div className="container-fluid InvoiceTheme shadow sidemenu-show">
                <div className="row">
                    <div className="col-md-11 col-sm-11">
                        <h5 className="align-center" style={{ fontWeight: "500" }}>Invoice System</h5>
                    </div>
                    <div data-tip="Import Quotation" onClick={hideQuotationModal}
                        className={`col-md-1 col-sm-1 align-center cursor ${CurrentTheme}Color`}
                        style={{ fontSize: "1.4rem" }}>
                        <FontAwesomeIcon icon={faReceipt} />
                    </div>
                </div>
                <div className="row title customerStyle">
                    <div className="col-md-3 col-sm-3 align-center">
                        <h5 style={{ fontWeight: "600" }}>Customer Name :</h5>
                    </div>
                    {selectedCustomer.length > 0 && selectedCustomer[0].Name !== null && selectedCustomer[0].Name !== undefined ? (<div className="col-md-6 col-sm-6 align-center">
                        <h5 style={{ fontWeight: "600" }}>{selectedCustomer[0].Name + (selectedCustomer[0].CompanyName !== "" ? (" [" + selectedCustomer[0].CompanyName + "]") : "")}</h5>
                    </div>) : (<div style={{ borderBottom: "1px solid #ccc" }} className="col-md-6 col-sm-6">
                    </div>)}
                    {SelectedQuotationInfo.length > 0 && (<div className="col-md-3 col-sm-3 align-right">
                        <button className={`btn btn-General ${CurrentTheme}Focus`} style={{ width: "150px" }} onClick={GenerateInvoice}> <FontAwesomeIcon icon={faSyncAlt} style={{ marginRight: "5px" }} /> Generate</button>
                    </div>)}
                </div>
                {SelectedQuotationInfo.length > 0 && (<div className="row title">
                    <div className="col-md-12">
                        <table className="table table-striped">
                            <thead>
                                <tr>
                                    <th className="align-center InvoicePDFtitleStyle" >No.</th>
                                    <th className="align-left InvoicePDFtitleStyle">Particular</th>
                                    <th className="align-center InvoicePDFtitleStyle">Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr className="align-center">
                                    <td>1</td>
                                    <td className="align-left">Wrapping & Packing Charges</td>
                                    <td className="align-center">{SelectedQuotationInfo.length > 0 && SelectedQuotationInfo[0].PackingCharges.toFixed(2)}</td>
                                </tr>
                                <tr className="align-center">
                                    <td>2</td>
                                    <td className="align-left">Loading & Stuffing Charges</td>
                                    <td className="align-center">{SelectedQuotationInfo.length > 0 && SelectedQuotationInfo[0].LoadingCharges.toFixed(2)}</td>
                                </tr>
                                <tr className="align-center">
                                    <td>3</td>
                                    <td className="align-left">Pickup & Delivery Charges</td>
                                    <td className="align-center">{SelectedQuotationInfo.length > 0 && SelectedQuotationInfo[0].PickupCharges.toFixed(2)}</td>
                                </tr>
                                <tr className="align-center">
                                    <td>4</td>
                                    <td className="align-left">Moving & Transport Charges</td>
                                    <td className="align-center">{SelectedQuotationInfo.length > 0 && SelectedQuotationInfo[0].TransportCharges.toFixed(2)}</td>
                                </tr>
                                <tr className="align-center">
                                    <td>5</td>
                                    <td className="align-left">Unloading Charges</td>
                                    <td className="align-center">{SelectedQuotationInfo.length > 0 && SelectedQuotationInfo[0].UnloadingCharges.toFixed(2)}</td>
                                </tr>
                                <tr className="align-center">
                                    <td>6</td>
                                    <td className="align-left">Unpacking & Settling Charges</td>
                                    <td className="align-center">{SelectedQuotationInfo.length > 0 && SelectedQuotationInfo[0].UnpackingCharges.toFixed(2)}</td>
                                </tr>
                                <tr className="align-center">
                                    <td>7</td>
                                    <td className="align-left">Automobile Transport Charges</td>
                                    <td className="align-center">{SelectedQuotationInfo.length > 0 && SelectedQuotationInfo[0].CarTransportCharges.toFixed(2)}</td>
                                </tr>
                                <tr className="align-center">
                                    <td>8</td>
                                    <td className="align-left">Other Charges</td>
                                    <td className="align-center">{SelectedQuotationInfo.length > 0 && SelectedQuotationInfo[0].OtherCharges.toFixed(2)}</td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td className="align-center"><b>Amount</b></td>
                                    <td className="align-center">
                                        {totalAmount}
                                    </td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td className="align-center"><b>GST (5%)</b></td>
                                    <td className="align-center">
                                        {(parseFloat(totalAmount) * 0.05).toFixed(2)}
                                    </td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td className="align-center"><b>GRAND TOTAL</b></td>
                                    <td className="align-center">
                                        {(parseFloat(totalAmount) + (parseFloat(totalAmount) * 0.05)).toFixed(2)}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>)}
            </div>
            <div id="SelectPrevQuotation" className="modal" style={{ display: hideQuotation }}>
                <div className="modal-content">
                    <div className={`modal-header header-style align-center ${CurrentTheme}`}>
                        <span style={{ marginLeft: "5px", padding: "5px" }}>Select Quotation</span>
                        <span className="close" onClick={hideQuotationModal}>&times;</span>
                    </div>

                    <table className="table tableTDWidthStyle">
                        <tbody>
                            <tr>
                                <td style={{ width: "50%" }}>
                                    <h5 style={{ paddingLeft: "10px" }}>Quotation<span className="mandatoryStar">*</span></h5>
                                </td>
                                <td style={{ width: "70%" }}>
                                    <div>
                                        <Select isClearable={true} isSearchable={true} placeholder="Select Quotation"
                                            options={QuotationInfo}
                                            onChange={SelectedQuotationChange}></Select>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ width: "50%" }}>
                                    <h5 style={{ paddingLeft: "10px" }}>Delivery Type</h5>
                                </td>
                                <td>
                                    <span><input style={{ marginRight: "4px" }} checked={InterState} type="checkbox" onChange={e => OnCheckedChange(e)}></input><span style={{ paddingLeft: "10px" }}>InterState Delivery</span></span>
                                </td>
                            </tr>
                            <tr>
                                <td style={{ width: "50%" }}>
                                    <h5 style={{ paddingLeft: "10px" }}>Credit<span className="mandatoryStar">*</span></h5>
                                </td>
                                <td style={{ width: "70%" }}>
                                    <div className="basic-select">
                                        <select className="DropdownStyle" style={{ width: "90%" }} onChange={(e) => getCreditPaymentDetails(e.target.value)}>
                                            <option value="0">Select Credit</option>
                                            <option value="1">Full Payment</option>
                                            <option value="2">Partial Payment</option>
                                        </select>
                                    </div>
                                </td>
                            </tr>
                            {InterState && (<tr>
                                <td style={{ width: "50%" }}>
                                    <h5 style={{ paddingLeft: "10px" }}>IGST<span className="mandatoryStar">*</span></h5>
                                </td>
                                <td>
                                    <input type="number" name="IGst" min="0" step="any" className="form-control"
                                        onChange={e => onNumberChange(e)} value={Gst.IGst ? Gst.IGst : 0}></input>
                                </td>
                            </tr>)}
                            {!InterState && (<tr>
                                <td style={{ width: "50%" }}>
                                    <h5 style={{ paddingLeft: "10px" }}>CGST<span className="mandatoryStar">*</span></h5>
                                </td>
                                <td>
                                    <input type="number" name="CGst" min="0" step="any" className="form-control"
                                        onChange={e => onNumberChange(e)} value={Gst.CGst ? Gst.CGst : 0}></input>
                                </td>
                            </tr>)}
                            {!InterState && (<tr>
                                <td style={{ width: "50%" }}>
                                    <h5 style={{ paddingLeft: "10px" }}>SGST<span className="mandatoryStar">*</span></h5>
                                </td>
                                <td>
                                    <input type="number" name="SGst" min="0" step="any" className="form-control"
                                        onChange={e => onNumberChange(e)} value={Gst.SGst ? Gst.SGst : 0}></input>
                                </td>
                            </tr>)}
                            <tr>
                                <td style={{ textAlign: "right" }} colSpan="2">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <button type="button" style={{ fontSize: "1.4rem" }} className={`btn btn-Save ${CurrentTheme}Focus`} onClick={ImportQuotationDetails}>Select</button>
                                            <button type="button" className="btn btn-default" onClick={hideQuotationModal}>Close</button>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    );
};

export default FinalInvoice;